import React,{forwardRef} from 'react'
import FinalSetupForm from './FinalSetupForm'

const FinalSetupUpdateDrawer = forwardRef((props, ref) => {
    const {
        othersFormSave,
        othersFormUpdateState,
        formValidateError,
        formData
    } = props;
    return (
        <>
            <div className='row p-5'>
                <div className='col-md-12'>
                    <FinalSetupForm
                        othersFormSave={othersFormSave}
                        othersFormUpdateState={othersFormUpdateState}
                        formValidateError={formValidateError}
                        formActionType={'update'}
                        formData={formData}
                        ref={ref}
                    />
                </div>
            </div>
            
        </>
    )
})

export default FinalSetupUpdateDrawer